/**
 * True when the request arrived on a South Australia host (sa.* or sa-staging.*).
 *
 * The SA microsite's own domain now proxies straight to this app, and its landing page has to
 * answer at `/` — a path `/sa` cannot be aliased onto, because the national home page owns it.
 * Branching on the host rather than rewriting the path is what keeps hydration correct: the
 * server and the browser see the same host string, whereas a rewritten path would leave the
 * client router looking for a route the URL doesn't name.
 */
export const useIsSaHost = () => {
  const [subdomain] = useRequestURL().hostname.split('.')

  return subdomain === 'sa' || subdomain.startsWith('sa-')
}
